// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1zzDT","rootSuccess":"CompleteLink_rootSuccess__3PsWb","rootFailure":"CompleteLink_rootFailure__2GqHI","isDisabled":"CompleteLink_isDisabled__kujne"};